import { Config } from "src/app/services/env.config";

export const ServerBranch  = {
    //typeOfServer: 'Local', 
    typeOfServer: 'Production',
    //typeOfServer: 'Test',

    // BaseEndpoint : 'http://121.242.201.103:1443/DealerDelight_web/IBD_DealerPortal_web/WcfDealerPortal.svc',
    // ImageEndpoint : 'http://121.242.201.103:1443/DealerDelight_web/IBD_DealerPortal_web/',
    // LoginEndpoint : 'http://121.242.201.103:1443/DealerDelight_web/IBD_DealerPortal_web/WcfDealerPortal.svc',
    // LogoutEndpoint : 'http://121.242.201.103:1443/LoginPage.aspx',

 

    //Production server 
    BaseEndpoint : 'https://ibdindents.titan.in/IBD_DealerPortal_web/WcfDealerPortal.svc',
    ImageEndpoint : 'https://ibdindents.titan.in/IBD_DealerPortal_web/',
    LoginEndpoint : 'https://ibdindents.titan.in/IBD_DealerPortal_web/WcfDealerPortal.svc',
    LogoutEndpoint : 'https://ibdindents.titan.in/LoginPage.aspx',

      
    //Uat TEST Server
    // BaseEndpoint : 'https://uat-connect.titan.in/DealerDelight_web/IBD_DealerPortal_web/WcfDealerPortal.svc',
    // ImageEndpoint : 'https://uat-connect.titan.in/DealerDelight_web/IBD_DealerPortal_web/',
    // LoginEndpoint : 'https://uat-connect.titan.in/DealerDelight_web/IBD_DealerPortal_web/WcfDealerPortal.svc',
    // LogoutEndpoint : 'https://uat-connect.titan.in/DealerDelight_web/LoginPage.aspx',

// Local
// Test
// Production


getLogoutDomain(): string {
    switch (this.typeOfServer) {
      case 'Local':
        return Config.BaseEndpoint;
      case 'Test':
         return ServerBranch.BaseEndpoint;
      case 'Production':
       // return 'https://uat-connect.titan.in';
         return ServerBranch.BaseEndpoint;
      default:
        return "'self'";
    }
  
  }


}
